// extracted by mini-css-extract-plugin
module.exports = {"container":"Process_container__2fdYL","stage":"Process_stage__2qIwI","current":"Process_current__2B_2s","error":"Process_error__39jOZ"};